import { push } from 'react-router-redux';
import update from 'immutability-helper';
import Notifications from 'react-notification-system-redux';
import moment from "moment";

import { authLoginUserFailure } from '../../../actions/auth';
import { checkHttpStatus, parseJSON } from '../../../utils';
import {
  fetchCommissions,
  fetchCommissionsList,
  patchCommission,
  fetchCommissionsOverview,
  deleteCommision,
  fetchCommissionInvoice
} from '../../../core/api';
// ------------------------------------
// Constants
// ------------------------------------
export const COMMISSION_FETCH_FAILURE = 'COMMISSION_FETCH_FAILURE';
export const COMMISSION_FETCH_REQUEST = 'COMMISSION_FETCH_REQUEST';
export const COMMISSION_FETCH_SUCCESS = 'COMMISSION_FETCH_SUCCESS';
export const COMMISSION_EDIT_FAILURE = 'COMMISSION_EDIT_FAILURE';
export const COMMISSION_EDIT_REQUEST = 'COMMISSION_EDIT_REQUEST';
export const COMMISSION_EDIT_SUCCESS = 'COMMISSION_EDIT_SUCCESS';

export const COMMISSION_DELETE_REQUEST = 'COMMISSION_DELETE_REQUEST';
export const COMMISSION_DELETE_SUCCESS = 'COMMISSION_DELETE_SUCCESS';
export const COMMISSION_DELETE_FAILURE = 'COMMISSION_DELETE_FAILURE';



export const COMMISSION_OVERVIEW_FETCH_FAILURE = 'COMMISSION_OVERVIEW_FETCH_FAILURE';
export const COMMISSION_OVERVIEW_FETCH_REQUEST = 'COMMISSION_OVERVIEW_FETCH_REQUEST';
export const COMMISSION_OVERVIEW_FETCH_SUCCESS = 'COMMISSION_OVERVIEW_FETCH_SUCCESS';

export const COMMISSION_LIST_FETCH_FAILURE = 'COMMISSION_LIST_FETCH_FAILURE';
export const COMMISSION_LIST_FETCH_REQUEST = 'COMMISSION_LIST_FETCH_REQUEST';
export const COMMISSION_LIST_FETCH_SUCCESS = 'COMMISSION_LIST_FETCH_SUCCESS';

export const COMMISSION_INVOICE_DOWNLOAD_REQUEST = 'COMMISSION_INVOICE_DOWNLOAD_REQUEST';
export const COMMISSION_INVOICE_DOWNLOAD_SUCCESS = 'COMMISSION_INVOICE_DOWNLOAD_SUCCESS';
export const COMMISSION_INVOICE_DOWNLOAD_FAILURE = 'COMMISSION_INVOICE_DOWNLOAD_FAILURE';

export const CURRENCY_FILTER_SET = 'CURRENCY_FILTER_SET';

// ------------------------------------
// Actions
// ------------------------------------

function findByBidId(value) {
  return value.bid.id === this;
}

export function commissionFetchRequest() {
  return {
    type: COMMISSION_FETCH_REQUEST,
    payload: null,
  };
}
export function commissionFetchSuccess(json) {
  return {
    type: COMMISSION_FETCH_SUCCESS,
    payload: json
  };
}
export function commissionFetchFailure(json) {
  return {
    type: COMMISSION_FETCH_FAILURE,
    payload: json,
  };
}

export function commissionListFetchRequest() {
  return {
    type: COMMISSION_LIST_FETCH_REQUEST,
    payload: null,
  };
}
export function commissionListFetchSuccess(json) {
  return {
    type: COMMISSION_LIST_FETCH_SUCCESS,
    payload: json
  };
}
export function commissionListFetchFailure(json) {
  return {
    type: COMMISSION_LIST_FETCH_FAILURE,
    payload: json,
  };
}

export function commissionOverviewFetchRequest() {
  return {
    type: COMMISSION_OVERVIEW_FETCH_REQUEST,
    payload: null,
  };
}
export function commissionOverviewFetchSuccess(json) {
  return {
    type: COMMISSION_OVERVIEW_FETCH_SUCCESS,
    payload: json
  };
}
export function commissionOverviewFetchFailure(json) {
  return {
    type: COMMISSION_OVERVIEW_FETCH_FAILURE,
    payload: json,
  };
}

export function commissionEditRequest() {
  return {
    type: COMMISSION_EDIT_REQUEST,
    payload: null,
  };
}
export function commissionEditSuccess(json) {
  return {
    type: COMMISSION_EDIT_SUCCESS,
    payload: json,
  };
}
export function commissionEditFailure(json) {
  return {
    type: COMMISSION_EDIT_FAILURE,
    payload: json,
  };
}
export function commissionDeleteRequest() {
  return {
    type: COMMISSION_DELETE_REQUEST,
    payload: null,
  };
}
export function commissionDeleteSuccess(json) {
  return {
    type: COMMISSION_DELETE_SUCCESS,
    payload: json,
  };
}
export function commissionDeleteFailure(json) {
  return {
    type: COMMISSION_DELETE_FAILURE,
    payload: json,
  };
}

export function downloadCommissionInvoiceRequest() {
  return {
    type: COMMISSION_INVOICE_DOWNLOAD_REQUEST,
    payload: null,
  };
}
export function downloadCommissionInvoiceSuccess(json) {
  return {
    type: COMMISSION_INVOICE_DOWNLOAD_SUCCESS,
    payload: json
  };
}
export function downloadCommissionInvoiceFailure(json) {
  return {
    type: COMMISSION_INVOICE_DOWNLOAD_FAILURE,
    payload: json,
  };
}

export function editCommission(payload) {
  return (dispatch) => {
    dispatch(commissionEditRequest(payload));
    return patchCommission(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(commissionEditSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(commissionEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editCommission(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editCommission(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(commissionEditFailure(payload));
      });
  };
}

export function requestCommission(page, column_name, filter_by_currency) {
  return (dispatch) => {
    dispatch(commissionFetchRequest());
    return fetchCommissions(page, column_name, filter_by_currency)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(commissionFetchSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              dispatch(commissionEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestCommission()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestCommission()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(commissionFetchFailure());
      });
  };
}

const EXTENSIONS = { 'application/pdf': 'pdf', 'application/vnd.ms-excel': 'xlsx' };

function handleCommissionBlobDownload(blob) {
  const filename = `commissions.${EXTENSIONS[blob.type.split(';')[0]]}`;
  if (navigator.appVersion.toString().indexOf('.NET') > 0) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const url = window.URL.createObjectURL(blob);
    const a = document.querySelector('#commissions-data-link');
    a.href = url;
    a.download = filename;
    a.click();
  }
}

function handleCommissionInvoiceBlobDownload(blob) {
  const dateTime = moment(moment.now()).format("YYYY-MM-DD-HH-mm-ss");
  const filename = `invoice${dateTime}.${EXTENSIONS[blob.type.split(';')[0]]}`;
  if (navigator.appVersion.toString().indexOf('.NET') > 0) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const url = window.URL.createObjectURL(blob);
    const a = document.querySelector('#commissions-data-link');
    a.href = url;
    a.download = filename;
    a.click();
  }
}


export function exportCommissionList(id,payload) {
  return (dispatch) => {
    dispatch(commissionListFetchRequest());
      const notificationOpts = {
      // uid: 'once-please', // you can specify your own uid if required
      title: 'Generating Doc',
      message: 'Exporting commissions data.',
      autoDismiss: 6,
    };
    dispatch(Notifications.success(notificationOpts));
    return fetchCommissionsList(id,payload)
      .then(checkHttpStatus)
       .then(response => response.blob())
      .then((blob) => {
        handleCommissionBlobDownload(blob);
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              // dispatch(commissionEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(exportCommissionList()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(exportCommissionList()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(commissionListFetchFailure());
      });
  };
}

export function downloadCommissionInvoice(id,payload) {
  return (dispatch) => {
    dispatch(downloadCommissionInvoiceRequest());
      const notificationOpts = {
      // uid: 'once-please', // you can specify your own uid if required
      title: 'Generating Doc',
      message: 'Exporting Commission Invoice',
      autoDismiss: 6,
    };
    dispatch(Notifications.success(notificationOpts));
    return fetchCommissionInvoice(id,payload)
      .then(checkHttpStatus)
       .then(response => response.blob())
      .then((blob) => {
        handleCommissionInvoiceBlobDownload(blob);
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              // dispatch(commissionEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(downloadCommissionInvoice()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(downloadCommissionInvoice()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(downloadCommissionInvoiceFailure());
      });
  };
}

export function requestCommissionOverview(filter_by_currency) {
  return (dispatch) => {
    dispatch(commissionOverviewFetchRequest());
    return fetchCommissionsOverview(0, filter_by_currency)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(commissionOverviewFetchSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              dispatch(commissionOverview(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestCommission()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestCommission()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(commissionFetchFailure());
      });
  };
}

export function removeCommission(payload, current_page, filterByCurrency, cb) {
  return (dispatch) => {
    dispatch(commissionDeleteRequest());
    return deleteCommision(payload)
      .then(checkHttpStatus)
      .then((response) => {
        const notificationOpts = {
          title: 'Delete Commission',
          message: 'Commission Deleted Successfully',
          autoDismiss: 5,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(commissionDeleteSuccess(response));
        dispatch(requestCommissionOverview(filterByCurrency));
        dispatch(requestCommission(current_page, null ,filterByCurrency));
        cb();
      })
      .catch((error) => {        
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(commissionDeleteFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeCommission(payload, current_page, cb)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeCommission(payload, current_page, cb)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(commissionDeleteFailure(payload));
      });
  };
}

export function currencyFilterSet(filter){
   return {
    type: CURRENCY_FILTER_SET,
    payload: filter,
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [COMMISSION_FETCH_REQUEST]: (state, action) => {
    return update(
      state,
      {
        $merge:
        {
          needFetch: false,
          isFetching: true,
        },
      },
    );
  },
  [COMMISSION_FETCH_SUCCESS]: (state, action) => {
    return update(
      state,
      {
        $merge:
        {
          isFetching: false,
          commissions: action.payload.results,
          count: action.payload.count
        },
      },
    );
  },

  [COMMISSION_OVERVIEW_FETCH_REQUEST]: (state, action) => {
    return update(
      state,
      {
        $merge:
        {
          commissionOverview: null
        },
      },
    );
  },
  [COMMISSION_OVERVIEW_FETCH_SUCCESS]: (state, action) => {
    return update(
      state,
      {
        $merge:
        {
          commissionOverview: action.payload.status
        },
      },
    );
  },
  [COMMISSION_EDIT_SUCCESS]: (state, action) => {
    const id = action.payload.bid.id;

    const commissions = state.commissions;
    const idx = commissions.findIndex(findByBidId, id);
    let newState;
    // Update bids
    if (idx === -1) {
      newState = update(state,
        {
          commissions:
            { $push: [action.payload] },
        });
    } else {
      newState = update(state,
        {
          commissions:
          {
            [idx]:
              { $set: action.payload },
          },
        });
    }
    return newState;
  },
  [CURRENCY_FILTER_SET]: (state, action) => {
    let newState;
    // Update currency filter
    if(action.payload){
      newState = update(state, {
        currencyFilter:  { $set: action.payload  },
      });
    }
    return newState;
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: false,
  needFetch: true,
  hasError: false,
  commissions: [],
  count: 0,
  commissionOverview: null,
  currencyFilter: {USD: true},
};

export default function registerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// src/routes/commissions/modules/commission.js